import React, { useState } from 'react';
import { Search, Mail } from 'lucide-react';
import { adminCustomers } from '../adminData';

function AdminCustomers() {
  const [search, setSearch] = useState('');
  const filtered = adminCustomers.filter(c => c.name.toLowerCase().includes(search.toLowerCase()));

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <div>
          <h1>Customers</h1>
          <p>View and manage your customer base.</p>
        </div>
      </div>

      <div className="admin-card">
        <div className="admin-toolbar">
          <div className="admin-search-box small">
            <Search size={16} />
            <input
              type="text"
              placeholder="Search customers..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>

        <div className="admin-table-wrapper">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Customer</th>
                <th>Email</th>
                <th>Country</th>
                <th>Orders</th>
                <th>Total Spent</th>
                <th>Joined</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(c => (
                <tr key={c.id}>
                  <td className="admin-td-name">
                    <div className="admin-avatar-name">
                      <div className="admin-mini-avatar">{c.name.charAt(0)}</div>
                      {c.name}
                    </div>
                  </td>
                  <td><Mail size={13} style={{ marginRight: 6, verticalAlign: 'middle' }} />{c.email}</td>
                  <td>{c.country}</td>
                  <td>{c.orders}</td>
                  <td className="admin-td-gold">{c.spent.toLocaleString()} SAR</td>
                  <td>{c.joined}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default AdminCustomers;
